module.exports = __webpack_public_path__ + "img/default-logo.9fe67e3a.png";